/**
 * Simple sound-effect manager using HTMLAudioElement pool.
 * Plays short sound clips with configurable volume and random selection.
 */

export class SoundManager {
  private readonly volume: number;
  private readonly sounds: Map<string, string>;
  private muted = false;

  constructor(sounds: Map<string, string>, volume = 0.5) {
    this.sounds = sounds;
    this.volume = volume;
  }

  /** Play a specific named sound. */
  public play(name: string): void {
    if (this.muted) return;
    const url = this.sounds.get(name);
    if (!url) return;

    const audio = new Audio(url);
    audio.volume = this.volume;
    audio.play().catch(() => {/* user hasn't interacted yet — ignore */});
  }

  /** Play a random variant of a sound category (e.g. 'coin' picks from coin-a,b,c,d). */
  public playRandom(prefix: string): void {
    if (this.muted) return;
    const variants: string[] = [];
    for (const name of this.sounds.keys()) {
      if (name.startsWith(prefix + '-')) {
        variants.push(name);
      }
    }
    if (variants.length === 0) return;
    const pick = variants[Math.floor(Math.random() * variants.length)];
    this.play(pick);
  }

  public toggleMute(): void {
    this.muted = !this.muted;
  }

  public isMuted(): boolean {
    return this.muted;
  }
}
